import { render } from "./DialogError.vue?vue&type=template&id=77b471f7&scoped=true"
import script from "./DialogError.vue?vue&type=script&lang=js"
export * from "./DialogError.vue?vue&type=script&lang=js"

import "./DialogError.vue?vue&type=style&index=0&id=77b471f7&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b471f7"]])

export default __exports__